import { render, staticRenderFns } from "./CompanyGridComponent.vue?vue&type=template&id=41ddd2aa&"
import script from "./CompanyGridComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports